import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'generic-database-picker.search-database-placeholder': {
    id: 'generic-database-picker.search-database-placeholder',
    defaultMessage: 'Search database',
    description:
      'The text placeholder for a database picker in the database referencing wizard.',
  },
  'generic-database-picker.menu-header': {
    id: 'generic-database-picker.menu-header',
    defaultMessage: 'RECENTLY VIEWED DATABASES',
    description:
      'The text heading the database picker menu in the database referencing wizard.',
  },
  'generic-database-picker.error-message': {
    id: 'generic-database-picker.error-message',
    defaultMessage: 'Select a valid database',
    description:
      'The error message displayed when there is a problem with the selected database',
  },
  'generic-database-picker.error-label': {
    id: 'generic-database-picker.error-label',
    defaultMessage: 'selection error',
    description:
      'The label for the error icon when there is a problem with the selected database',
  },
  'generic.page-picker.menu.option.description.last-updated': {
    id: 'generic.page-picker.menu.option.description.last-updated',
    defaultMessage: 'Updated {date}',
    description: 'The description for the page picker option.',
  },
});
